import React from "react";
import  ReactDOM  from "react-dom/client";
import eth from "./images/ethereum.svg"
import clock from "./images/icon-clock.svg";
import avatar from "./images/avatar.png";


export default function Main() {
    return(
   <main>
     <div className="first-div">
     <h1>Equilibrium #3429</h1>
       <p>Our Equilibrium colliction promotes balance and calm</p>
     </div>
     <div className="second-div">
        <div className="eth">
        <img src={eth} alt ="" />
        <small>0.041 ETH</small>
        </div>

        <div className="clock">
            <img src= {clock} alt = "" />
            <small>3 days left</small>
        </div>
     </div>
     <div className="third-div">
        <div className="third-div-image">
        <img src={avatar} alt ="" />
        </div>
      <div className="text">
      <p>Creation of<span className="span">Jules Wyvern </span> </p>
      </div>
     </div>
   </main>
    )
}